import React, { FC, useRef, useState } from 'react';
import Image from 'components/image/Image';
import { useTranslation } from 'react-i18next';

import './Index.scss';
import { useNavigate } from 'react-router';
import { DynamicActionButton } from 'components/newButtons/DynamicActionButton';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { IndustryList } from 'components/IndustryList';
import { clampText } from 'helpers/sharedFunctions';
import { CANDIDATE_ROUTES } from 'core/constants/candidateRoutes';
import ApplicationHistoryList from 'components/shared/ApplicationHistoryList/Index';
import { getCultureFitLabel } from 'helpers/cultureFitLabel';
import { formatTimestampedLine } from 'helpers/applicationHistory';

const OutgoingRequests: FC<any> = ({
  id,
  name,
  sub_title,
  email,
  icon,
  score,
  culture_score,
  date,
  history,
  industry,
  stageOutgoingHandler,
  status,
  setOpen,
  candidateId,
  jobTitle
}): JSX.Element => {
  const navigate = useNavigate();
  const [showIndustries, setShowIndustries] = useState(false);
  const industriesBtnRef = useRef<HTMLSpanElement>(null);
  const { t } = useTranslation();

  const user = useSelector((state: RootState) => state.user.user);
  const isRecruiterOrAdmin =
    user?.role === 'recruiter' || user?.role === 'admin';

  const canViewProfile =
    isRecruiterOrAdmin &&
    Array.isArray(user?.can_view_candidates) &&
    user.can_view_candidates.includes(Number(candidateId));

  const handleWithdraw = () => {
    stageOutgoingHandler(id, { status: 4 });
  };

  return (
    <div className="ORCard">
      <div className="ORCard__left">
        <div onClick={() => setOpen(id, 'outgoing-requests')}>
          <Image
            url={icon}
            name={!icon ? 'no-avatar.svg' : ''}
            className="ORCard__left-image"
            objectFit="cover"
          />
        </div>
        <div className="ORCard__left__info">
          <div className="ORCard__left__info_name">
            <div className="ORCard__left__info-name-container">
              <span className="ORCard__left__info-title">{name || email}</span>
              <span className="ORCard__left__info-job-title">{jobTitle}</span>
            </div>
            {industry && (
              <IndustryList
                industry={industry}
                showIndustries={showIndustries}
                setShowIndustries={setShowIndustries}
                industriesBtnRef={industriesBtnRef}
              />
            )}
          </div>
          <span className="ORCard__left__info-sub">
            {clampText(sub_title, 45)}
          </span>
        </div>
      </div>
      <div className="ORCard__middle">
        <div className="ORCard__middle__percents">
          <span className="ORCard__middle__matches-title">
            {' '}
            {score || 0}% {t('Talent Match')}
          </span>
          <span className="ORCard__middle__matches-title">
            {getCultureFitLabel(culture_score, t)}
          </span>
        </div>
        <div className="ORCard__middle__details">
          <div className="ORCard__middle__details__item">
            <span className="ORCard__middle__details__item-desc">
              {formatTimestampedLine(
                isRecruiterOrAdmin ? 'Request sent on' : 'Message send on',
                date,
                t,
                { includeOn: false }
              )}
            </span>
          </div>
          <ApplicationHistoryList
            history={history}
            classPrefix="ORCard"
            t={t}
          />
        </div>
      </div>
      <div className="ORCard__right">
        {isRecruiterOrAdmin ? (
          <div className="ORCard__right__actions">
            <DynamicActionButton
              label={t('More Info')}
              backgroundColor="#BEA0E5"
              onClick={() => setOpen(id, 'outgoing-requests')}
            />
            {status !== 4 && status !== 2 && (
              <DynamicActionButton
                label={t('Withdraw')}
                backgroundColor="red"
                onClick={handleWithdraw}
              />
            )}
            {canViewProfile && (
              <DynamicActionButton
                label={t('Profile')}
                backgroundColor="#A0D5E5"
                onClick={() => navigate(CANDIDATE_ROUTES.profile(candidateId))}
              />
            )}
          </div>
        ) : status === 2 ? (
          <div className="ORCard__right__actions">
            <DynamicActionButton
              label={t('Profile')}
              backgroundColor="#A0D5E5"
              onClick={() => navigate(CANDIDATE_ROUTES.profile(candidateId))}
            />
          </div>
        ) : (
          <div className="ORCard__right__actions">
            <DynamicActionButton
              label={t('More Info')}
              backgroundColor="#BEA0E5"
              onClick={() => setOpen(id, 'outgoing-requests')}
            />
            {status !== 4 && status !== 2 && (
              <DynamicActionButton
                label={t('Withdraw')}
                backgroundColor="red"
                onClick={handleWithdraw}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OutgoingRequests;
